<div [class]="collapsed ? 'd-flex' : null" (appResize)="updateTextTruncated()">
  <ng-content select="[preContent]"/>
  <div #textContainer
       [class]="collapsed
         ? 'shrinkable-flex-item collapsed'
         : 'd-inline'"
       [ngClass]="collapsed ? textHiddenClass : textUnhiddenClass"
       [innerHTML]="text">
  </div>
  <span #noPostContentEndMarker></span>
  @if (!hideButtons && textTruncated) {
    @if (canToggle) {
      <button type="button"
              class="btn btn-link btn-sm p-0 border-0"
              (click)="setCollapsed(!collapsed, $event)">
        <ng-container *ngTemplateOutlet="ellipsisText"/>
      </button>
    } @else {
      <ng-container *ngTemplateOutlet="ellipsisText"/>
    }
  }
  <div [class]="collapsed ? 'd-flex' : 'd-inline'" #postContentContainer>
    <ng-content select="[postContent]"/>
  </div>
  <span #endMarker></span>
</div>
<ng-template #ellipsisText>{{collapsed ? '&hellip;' : ('Show less' | messageTranslate)}}</ng-template>